"use client";

import dynamic from 'next/dynamic';
import { useEffect, useMemo, useState, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { getSignupVariant } from "@/utils/signupVariant";
const SignupFormVariant3 = dynamic(() => import("../../components/signupVariants/variant3"), {
  loading: () => <div>Loading...</div>,
  ssr: false
});
const SignupFormVariant4 = dynamic(() => import("../../components/signupVariants/variant4"), {
  loading: () => <div>Loading...</div>,
  ssr: false
});
function SignupPageInner() {
  const searchParams = useSearchParams();
  const [variant, setVariant] = useState(null);
  useEffect(() => {
    const assignedVariant = getSignupVariant({
      searchParams
    });
    setVariant(assignedVariant);
  }, [searchParams]);
  const SignupForm = useMemo(() => {
    if (variant === 'D') {
      return SignupFormVariant4;
    }
    return SignupFormVariant3;
  }, [variant]);
  useEffect(() => {
    if (!variant) return;
    window.clarity?.("set", "signup_page_loaded", true);
    try {
      const alreadyFired = sessionStorage.getItem("signup_page_view_once");
      if (!alreadyFired) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "signup_page_view",
          signup_variant: variant
        });
        sessionStorage.setItem("signup_page_view_once", "true");
      }
    } catch (_) {
      // sessionStorage unavailable (e.g. private browsing restrictions) — fire unconditionally
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "signup_page_view",
        signup_variant: variant
      });
    }
  }, [variant]);
  if (!variant) {
    return null;
  }
  return <div data-sentry-component="SignupPageInner" data-sentry-source-file="page.jsx">
      <SignupForm data-sentry-element="SignupForm" data-sentry-source-file="page.jsx" />
    </div>;
}
export default function SignupPage() {
  return <Suspense fallback={null} data-sentry-element="Suspense" data-sentry-component="SignupPage" data-sentry-source-file="page.jsx">
      <SignupPageInner data-sentry-element="SignupPageInner" data-sentry-source-file="page.jsx" />
    </Suspense>;
}